import { I as IMaskMixin, _ as _objectWithoutProperties } from './mixin-9a4bc4a3.js';
import React from 'react';
import 'prop-types';
import 'imask/esm/imask';

var _excluded = ["inputRef"];

var InputComponent = function InputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement('input', Object.assign({}, props, {
    ref: inputRef
  }));
};

var IMaskInput = IMaskMixin(InputComponent);

export { IMaskInput as default };
